import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  SimpleChange,
} from "@angular/core";
import * as moment from "moment";
import { environment } from "../../../environments/environment";

@Component({
  selector: "app-date-selector",
  templateUrl: "./date-selector.component.html",
  styleUrls: ["./date-selector.component.scss"],
})
export class DateSelectorComponent implements OnInit {
  @Input() datepickerMode: string;
  @Input() enabledDate: string[];

  @Output() onSelectDate = new EventEmitter<any>();

  en: boolean;
  dt: Date;
  showCalendar: boolean = false;

  @Input() startDate: Date;
  @Input() endDate: Date;

  dateDisabled: { date: Date; mode: string }[] = [];

  constructor() {
    this.en = environment.english;
    this.datepickerMode = this.datepickerMode ? this.datepickerMode : "day";
  }

  private _date: string;
  @Input()
  set date(date: string) {
    this._date = date || moment().format("YYYY-MM-DD");
    this.dt = moment(this._date, "YYYY-MM-DD").toDate();
  }

  ngOnInit() {
    if (this._date) {
      this.dt = moment(this._date, "YYYY-MM-DD").toDate();
    }
  }

  ngOnChanges(event: SimpleChange) {
    if (event["enabledDate"]) {
      let arr: string[] = event["enabledDate"].currentValue;
      this.dateDisabled = [];

      if (arr.length) {
        this.startDate = new Date(arr[0]);
        this.endDate = new Date(arr[arr.length - 1]);

        if (this.startDate != this.endDate) {
          let startDate = moment(arr[0], "YYYY-MM-DD");
          let endDate = moment(arr[arr.length - 1]);
          while (startDate.add(1, "days").diff(endDate) < 0) {
            if (arr.indexOf(startDate.format("YYYY-MM-DD")) < 0) {
              this.dateDisabled.push({ date: startDate.toDate(), mode: "day" });
            }
          }
        }
      }
    }
  }

  onSelectCalendar(event) {
    this.showCalendar = false;
    this.onSelectDate.emit(moment(event).format("YYYY-MM-DD"));
  }

  onSelectButton() {
    if (!this.dt) {
      if (this.date) {
        this.dt = moment(this.date, "YYYY-MM-DD").toDate();
      } else {
        this.dt = new Date();
      }
    }
    this.showCalendar = !this.showCalendar;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/date-selector/date-selector.component.ts